import { FunctionComponent, useState } from 'react';
import Slider from 'react-slick';
import SolutionProcessWrapper from './solutionProcess.style';
import ArrowIcon from '../../public/icon/Arrow';
import { getStaticImageUrl } from '@utils/createImageUrl';

const SolutionProcess: FunctionComponent = () => {
  const solutionProcesss = [
    {
      mobileImage: getStaticImageUrl({ fileName: 'schedule_mobile.jpg' }),
      desktopImage: getStaticImageUrl({ fileName: 'schedule_desktop.jpg' }),
      description: '변호사님이 원하시는 상담시간과 금액을 설정합니다.',
    },
    {
      mobileImage: getStaticImageUrl({ fileName: 'typing_mobile.png' }),
      desktopImage: getStaticImageUrl({ fileName: 'typing_desktop.jpg' }),
      description: '예약 과정에서 의뢰인은 상담내용을 작성하고, 결제를 합니다.',
    },
    {
      mobileImage: getStaticImageUrl({ fileName: 'consulting_mobile.jpg' }),
      desktopImage: getStaticImageUrl({ fileName: 'consulting_desktop.jpg' }),
      description: '예약 시간에 <br/>전화/영상/방문상담을 <br class="mobile"/>진행합니다.',
    },
    {
      mobileImage: getStaticImageUrl({ fileName: 'consulting-result_mobile.png' }),
      desktopImage: getStaticImageUrl({ fileName: 'consulting-result_desktop.jpg' }),
      description: '상담 종료 후, <br class="mobile"/>변호사님은 상담결과지를 작성할 수 있습니다.',
    },
  ];
  const [currentSlide, setCurrentSlide] = useState(0);
  function SamplePrevArrow(props: any) {
    const { className, style, onClick } = props;
    if (currentSlide > 0) {
      return (
        <div
          className={className}
          style={{ ...style, transform: 'rotate(90deg)', left: '44px', top: 'calc(50% - 11px)', zIndex: '2' }}
          onClick={onClick}
        >
          <ArrowIcon width="25px" height="25px" />
        </div>
      );
    } else {
      return <></>;
    }
  }
  function SampleNextArrow(props: any) {
    const { className, style, onClick } = props;
    if (currentSlide < solutionProcesss.length - 1) {
      return (
        <div
          className={className}
          style={{
            ...style,
            transform: 'rotate(-90deg)',
            left: 'calc(100vw - 73px)',
            top: 'calc(50% - 10px)',
            zIndex: '5',
          }}
          onClick={onClick}
        >
          <ArrowIcon width="25px" height="25px" />
        </div>
      );
    } else {
      return <></>;
    }
  }

  const settings = {
    className: 'slider variable-width',
    centerMode: true,
    autoplay: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    beforeChange: (_: number, next: number) => {
      setCurrentSlide(next);
    },
  };
  return (
    <SolutionProcessWrapper>
      <div className="solutionprocess--header">
        <p className="solutioncomp--subtitle">Process</p>
        <p className="solutioncomp--title">어떻게 진행되나요?</p>
      </div>
      <div className="solutionprocess--body mobile">
        <div className="solutionprocess--carouselwrap">
          <div className="solutionprocess--cloud left" />
          <div className="solutionprocess--cloud right" />
          <div className="solutionprocess--index-wrap">
            {solutionProcesss.map((_, index) => (
              <p className={`solutionprocess--index ${currentSlide === index && 'active'}`} key={index}>
                {index + 1}
              </p>
            ))}
          </div>
          {/* 
            // @ts-ignore */}
          <div className="solutionprocess--list">
            <Slider {...settings}>
              {solutionProcesss.map((process, index) => (
                <div className="solutionprocess--item" key={index}>
                  <img className="solutionprocess--item-image" src={process.mobileImage} />
                </div>
              ))}
            </Slider>
          </div>
        </div>
        <p
          className="solutionprocess--item-desc"
          dangerouslySetInnerHTML={{ __html: solutionProcesss[currentSlide].description }}
        ></p>
      </div>
      <div className="solutionprocess--body desktop">
        <div className="solutionprocess--list">
          {solutionProcesss.map((process, index) => (
            <div className="solutionprocess--item" key={index}>
              {index !== solutionProcesss.length - 1 && (
                <div className="solutionprocess--item-arrow">
                  <ArrowIcon width="12px" height="12px" />
                </div>
              )}
              <div className="solutionprocess--index-wrap">
                <p className="solutionprocess--index active">{index + 1}</p>
              </div>
              <p className="solutionprocess--item-desc" dangerouslySetInnerHTML={{ __html: process.description }} />
              <img className="solutionprocess--item-image" src={process.desktopImage} />
            </div>
          ))}
        </div>
      </div>
    </SolutionProcessWrapper>
  );
};

export default SolutionProcess;
